import { useState, useEffect } from 'react';
import { IAttendee } from '@src/webinar/types';
import { useTable } from '@src/shared/OTable/useTable';

export const useAccordionSelection = (
  data: IAttendee[],
  setSelectedAttendees: (attendees: IAttendee[]) => void,
  tableRef?: React.MutableRefObject<any>
) => {
  const [selectedRows, setSelectedRows] = useState<string[]>([]);

  const handleToggle = (attendee: IAttendee) => {
    const id = attendee._id;
    const updated = selectedRows.includes(id) ? selectedRows.filter((item) => item !== id) : [...selectedRows, id];

    setSelectedRows(updated);
    const updatedAttendees = data.filter((a) => updated.includes(a._id));
    setSelectedAttendees(updatedAttendees);
  };

  const [expanded, setExpanded] = useState<string | false>(false);

  const handleAccordionToggle = (panelId: string) => (_event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panelId : false);
  };

  useEffect(() => {
    if (!!tableRef) {
      tableRef.current = {
        getRowModel: () => ({
          rows: data.map((item) => ({
            original: item,
          })),
        }),
        toggleAllRowsSelected: (value: boolean) => {
          if (value) {
            const allIds = data.map((item) => item._id);
            setSelectedRows(allIds);
            setSelectedAttendees(data);
          } else {
            setSelectedRows([]);
            setSelectedAttendees([]);
          }
        },
        resetRowSelection: () => {
          setSelectedRows([]);
          setSelectedAttendees([]);
        },
      };
    }
  }, [data]);

  return {
    selectedRows,
    handleToggle,
    expanded,
    setExpanded,
    handleAccordionToggle,
  };
};
